<template src="./index.html"></template>
<style src="./style.scss" lang="scss" scoped></style>
<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import validator from 'validator';
 
import Navbar from '@/components/Navbar';
import InputField from '@/components/InputField';
import Background from '@/components/Background';
import BackButton from '@/components/BackButton';

export default {
  name: 'InviteTeam',
  components: {
    Navbar,
    InputField,
    Background,
    BackButton
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      error: '',
      step: 0
    };
  },

  methods: {
    validateForm() {
      this.error = '';

      // validate the phone number
      if (!validator.isMobilePhone(this.phone, 'en-US')) {
        this.error = 'Whoops, looks like phone number is incorrect';
        this.$refs.phone.setError(this.error);
      }

      // validate the email address
      if (!validator.isEmail(this.email)) {
        this.error = 'Whoops, looks like email address is incorrect';
        this.$refs.email.setError(this.error);
      }
    },
    encode(data) {
      return Object.keys(data)
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
        .join('&');
    },
    onClickContinue() {
      if (this.step === 0) {
        this.validateForm();

        if (!this.error) {
          const axiosConfig = {
            header: { 'Content-Type': 'application/x-www-form-urlencoded' }
          };
          axios
            .post(
              '/',
              this.encode({
                'form-name': 'number-porting',
                'firstName': this.firstName,
                'lastName': this.lastName,
                'phone': this.phone,
                'email': this.email
              }),
              axiosConfig
            )
            .then(() => {
              this.step = 1;
            });
        }
      } else {
        this.$router.push('/');
      }
    }
  }
};
</script>
